export default "__VITE_ASSET__DrKHkcCJ__"